<template>
    <div class="form-item__container">
        <input
            :type="showPassword ? 'text' : 'password'"
            v-model="model"
            class="form-item__field"
            v-bind="({ name, placeholder } = inputProps)"
        />
        <span class="material-icons-outlined password-input__icon" @click="toggleShow">{{
            showPassword ? 'visibility_off' : 'visibility'
        }}</span>
    </div>
</template>

<script>
import { proxyModelMixin } from '@/mixins/proxyModelMixin';

export default {
    name: 'input-password',
    props: {
        modelValue: { type: String, default: '' },
        name: { type: String, default: '' },
        group: { type: String, default: null },
        placeholder: { type: String, default: '' },
    },
    data() {
        return {
            showPassword: false,
        };
    },
    mixins: [proxyModelMixin],
    computed: {
        inputProps() {
            return {
                name: this.name,
                placeholder: this.placeholder,
            };
        },
    },
    methods: {
        toggleShow() {
            this.showPassword = !this.showPassword;
        },
    },
    watch: {
        modelValue: function (newValue) {
            this.$emit('update-field', {
                name: this.name,
                group: this.group,
                value: newValue,
            });
        },
    },
};
</script>

<style lang="scss">
.password-input {
    &__icon {
        position: absolute;
        right: 18px;
        top: 38px;
        color: #787878;
        cursor: pointer;
        transition: all 0.2s;
        &:hover {
            transition: all 0.2s;
            color: initial;
        }
    }
}
</style>
